export default __webpack_public_path__ + "static/media/Misc.00b19978.svg";